import { Helmet } from "react-helmet";
import ArasusCaseStudyBody from "../../components/case-studies/cases/ArasusCaseStudyBody";
import CaseStudyHero from "../../components/case-studies/cases/reusables/CaseStudyHero";
import desktop from "../../assets/images/case-studies/cases/arasus/arasus-desktop.jpg";
import SolutionsNtunaCTAWorld from "../../components/solutions/SolutionsNtunaCTAWorld";

export default function Arasus() {
  return (
    <>
      <Helmet> 
        <link
          rel="canonical"
          href="https://www.ntuna.com/case-studies/arasus"
        />
        <meta
          name="description"
          content="Explore how NTUNA.COM delivered a high-performance website, payments integration, Google workspace setup and social media accounts setup for Arasus Aviation entering the Ugandan market."
        />
        <meta
          property="og:description"
          content="Explore how NTUNA.COM delivered a high-performance website, payments integration, Google workspace setup and social media accounts setup for Arasus Aviation entering the Ugandan market."
        />
        <meta
          property="og:title"
          content="Arasus Aviation Case Study | Website design & Social media setup | NTUNA.COM"
        />
        <meta
          property="og:image"
          content="https://res.cloudinary.com/malidad/image/upload/v1779608354/ntuna-head-office_banner-1200x628_qeg2go.jpg"
        />

        <meta
          name="twitter:title"
          content="Arasus Aviation Case Study | Website design & Social media setup | NTUNA.COM"
        />
        <meta
          name="twitter:text:title"
          content="Arasus Aviation Case Study | Website design & Social media setup | NTUNA.COM"
        />
        <meta
          name="twitter:description"
          content="Explore how NTUNA.COM delivered a high-performance website, payments integration, Google workspace setup and social media accounts setup for Arasus Aviation entering the Ugandan market."
        />
        <meta
          name="twitter:image"
          content="https://res.cloudinary.com/malidad/image/upload/v1779608354/ntuna-head-office_banner-1200x628_qeg2go.jpg"
        />
        <title>
          Arasus Aviation Case Study | Website design & Social media setup |
          NTUNA.COM
        </title>
      </Helmet>
      <CaseStudyHero
        client="Arasus Aviation"
        title="Arasus Aviation"
        subtitle="We delivered a high-performance website, seamless payment integration, social media accounts setup, social media ads, CCTV Installation and a company management system for a new aviation brand entering the Ugandan market."
        caseImg={desktop}
      />
      <ArasusCaseStudyBody />
      <SolutionsNtunaCTAWorld />
    </>
  );
}
